import logo from '../img/logo/logo.png';

const Footer = () => {
  return (
    <footer className="text-gray-600 body-font">
      <div
        className="
          container
          px-5
          pt-24
          pb-10
          mx-auto
          flex
          md:items-center
          lg:items-start
          md:flex-row md:flex-nowrap
          flex-wrap flex-col
        "
      >
        <div
          className="
            w-64
            flex-shrink-0
            md:mx-0
            mx-auto
            text-center
            md:text-left
          "
        >
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.facebook.com/Sliceofdream"
            className="
              flex
              title-font
              font-medium
              items-center
              md:justify-start
              justify-center
              text-gray-600
            "
          >
            <img className="w-14" src={logo} alt="logo" />
            <h1 className="ml-3 text-2xl">Slice of Dreams</h1>
          </a>
          <p className="logo-title text-sm text-gray-600 text-center -mt-3 ml-2">
            Online Cake Shop
          </p>
        </div>
        <div
          className="
            flex-grow flex flex-wrap
            md:pl-20
            -mb-10
            md:mt-0
            mt-10
            md:text-left
            text-center
          "
        >
          <div className="flex-auto lg:w-1/4 md:w-1/2 w-full px-4">
            <h2
              className="
                title-font
                font-medium
                text-gray-600
                tracking-wider
                text-2xl
                mb-3
              "
            >
              Services
            </h2>
            <nav className="list-none mb-10">
              <li>
                <a
                  href="#services"
                  className="text-gray-600 hover:text-purple-500"
                >
                  Delivery
                </a>
              </li>
              <li>
                <a href="#menu" className="text-gray-600 hover:text-purple-500">
                  Menu
                </a>
              </li>
              <li>
                <a href="#menu" className="text-gray-600 hover:text-purple-500">
                  Pricing
                </a>
              </li>
            </nav>
          </div>
          <div className="flex-auto lg:w-1/4 md:w-1/2 w-full px-4">
            <h2
              className="
                title-font
                font-medium
                text-gray-600
                tracking-wider
                text-2xl
                mb-3
              "
            >
              Information
            </h2>
            <nav className="list-none mb-10">
              <li>
                <a
                  href="#contact"
                  className="text-gray-600 hover:text-purple-500"
                >
                  Contact Us
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/Sliceofdream"
                  className="text-gray-600 hover:text-purple-500"
                >
                  Order Cake
                </a>
              </li>
              <li>
                <a href="/" className="text-gray-600 hover:text-purple-500">
                  Terms & Conditions
                </a>
              </li>
            </nav>
          </div>
          <div className="flex-auto lg:w-1/4 md:w-1/2 w-full px-4">
            <h2
              className="
                title-font
                font-medium
                text-gray-600
                tracking-wider
                text-2xl
                mb-3
              "
            >
              Social Handles
            </h2>
            <nav className="list-none mb-10">
              <li>
                <p className="text-gray-600 hover:text-purple-500">
                  01787-528206
                </p>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://api.whatsapp.com/send?phone=8801787528206&fbclid=IwAR0SlTVzwTnpg79o3ByXCxEajUCLKOpBP7MAXe2q1ewjx_bjrSsyEUlM52g"
                  className="text-gray-600 hover:text-purple-500"
                >
                  WhatsApp
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.facebook.com/Sliceofdream"
                  className="text-gray-600 hover:text-purple-500"
                >
                  Facebook
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.instagram.com/slice_of_dreams_by_nasreen/"
                  className="text-gray-600 hover:text-purple-500"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://mail.google.com/mail/u/0/#inbox?compose=new"
                  className="text-gray-600 hover:text-purple-500"
                >
                  chowdhurynasrin1@gmail.com
                </a>
              </li>
            </nav>
          </div>
        </div>
      </div>
      <div className="bg-gray-100">
        <div
          className="
            container
            mx-auto
            py-4
            px-5
            flex flex-wrap flex-col
            sm:flex-row
          "
        >
          <p className="text-gray-500 text-sm text-center sm:text-left">
            © 2021 Slice of Dreams —
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/Sliceofdream"
              className="text-gray-600 ml-1"
            >
              @sliceofdreams
            </a>
          </p>
          <span
            className="
              inline-flex
              sm:ml-auto
              sm:mt-0
              mt-2
              justify-center
              sm:justify-start
            "
          >
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/Sliceofdream"
              className="text-gray-500"
            >
              <svg
                fill="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                className="w-5 h-5"
                viewBox="0 0 24 24"
              >
                <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
              </svg>
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/slice_of_dreams_by_nasreen/"
              className="ml-3 text-gray-500"
            >
              <svg
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                className="w-5 h-5"
                viewBox="0 0 24 24"
              >
                <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
                <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
              </svg>
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
